export const bcAuthEvents = {
  loginSuccess: 'bc-auth-login-success',
  loginFailed: 'bc-auth-login-failed',
  clientAvailable: 'bc-client-available',
  logoutSuccess: 'bc-auth-logout-success',
  sessionTimeout: 'bc-auth-session-timeout',
  notAuthenticated: 'bc-auth-not-authenticated',
  notAuthorized: 'bc-auth-not-authorized',
  refreshTokenIntervalName: 'bc-refresh-token-interval',
  promptAwayRequired: 'bc-prompt-away-required'
};
